import { getDefaultPathByRole, routersPath } from '../router/routes-path'
import { useUserSelector } from '../store/selectors/auth'

export const useDefaultPath = (): routersPath => {
  const user = useUserSelector()
  return getDefaultPathByRole(user?.role)
}
